<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
document.querySelectorAll('.faq-question').forEach(function(question) {
  question.addEventListener('click', function() {
    const item = this.parentElement;
    item.classList.toggle('active');
  });
});